import { BrowserRouter, Routes, Route } from "react-router-dom";
import { KiddiesBankPage } from "./pages";
import BvnValidation from "./components/bvnValdate";
import { Success } from "./components";
import '../src/assets/css/main.css'
import '../src/assets/css/navbar.css'
import '../src/assets/css/blog.css'
import '../src/assets/css/dark.css'
import '../src/assets/css/rtl.css'
import '../src/assets/css/loader.css'
import PageNotFound from "./pages/PageNotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
      <Route path={"/openKiddiesAccount"} element={<BvnValidation />} />
      <Route path={"/openKiddiesAccount/success"} element={<Success />} />  
      <Route path={"/openKiddiesAccount/create-account"} element={<KiddiesBankPage />} />  
      <Route path={"*"} element={<PageNotFound />} />  
      </Routes>
    </BrowserRouter>
  );
}

export default App;
